<div class="gu-form-dialog">
  <div class="gu-dialog__header">
    <span class="gu-dialog__title">
      {{ (mode === 'create' ? 'USUARIOS.CREATE_TITLE' : 'USUARIOS.EDIT_TITLE') | translate }}
    </span>
    <button type="button" class="gu-icon-btn" (click)="cancel()" [attr.aria-label]="'COMMON.CLOSE' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" class="gu-dialog__body" (ngSubmit)="save()">

    <div class="gu-section-label">{{ 'USUARIOS.SECTION_PERSONAL' | translate }}</div>
    <div class="gu-grid-2">
      <div class="gu-field">
        <label>{{ 'COMMON.NAME' | translate }} *</label>
        <input type="text" class="gu-input" formControlName="nombre" />
        <span class="gu-error" *ngIf="form.get('nombre')?.touched && form.get('nombre')?.invalid">{{ 'COMMON.REQUIRED' | translate }}</span>
      </div>
      <div class="gu-field">
        <label>{{ 'PROFILE.SURNAME1' | translate }} *</label>
        <input type="text" class="gu-input" formControlName="apellido1" />
        <span class="gu-error" *ngIf="form.get('apellido1')?.touched && form.get('apellido1')?.invalid">{{ 'COMMON.REQUIRED' | translate }}</span>
      </div>
      <div class="gu-field">
        <label>{{ 'PROFILE.SURNAME2' | translate }}</label>
        <input type="text" class="gu-input" formControlName="apellido2" />
      </div>
      <div class="gu-field">
        <label>{{ 'COMMON.DNI' | translate }} *</label>
        <input type="text" class="gu-input" formControlName="numero_documento" />
        <span class="gu-error" *ngIf="form.get('numero_documento')?.touched && form.get('numero_documento')?.invalid">{{ 'COMMON.REQUIRED' | translate }}</span>
      </div>
      <div class="gu-field gu-field--full">
        <label>{{ 'COMMON.EMAIL' | translate }} *</label>
        <input type="email" class="gu-input" formControlName="email" />
        <span class="gu-error" *ngIf="form.get('email')?.touched && form.get('email')?.invalid">{{ 'USUARIOS.INVALID_EMAIL' | translate }}</span>
      </div>
      <div class="gu-field gu-field--full">
        <label>{{ 'COMMON.PHONE' | translate }}</label>
        <input type="text" class="gu-input" formControlName="telefono" />
      </div>
    </div>

    <hr class="gu-divider" />

    <div class="gu-section-label">
      {{ 'USUARIOS.SECTION_PASSWORD' | translate }}
      <span class="gu-section-hint" *ngIf="mode === 'edit'">{{ 'USUARIOS.PASSWORD_HINT' | translate }}</span>
    </div>
    <div class="gu-grid-2">
      <div class="gu-field">
        <label>{{ 'COMMON.PASSWORD' | translate }} {{ mode === 'create' ? '*' : '' }}</label>
        <input type="password" class="gu-input" formControlName="password" autocomplete="new-password" />
        <span class="gu-error" *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
          {{ 'USUARIOS.PASSWORD_MIN' | translate }}
        </span>
      </div>
      <div class="gu-field">
        <label>{{ 'PROFILE.CONFIRM_PASSWORD' | translate }} {{ mode === 'create' ? '*' : '' }}</label>
        <input type="password" class="gu-input" formControlName="confirmPassword" autocomplete="new-password" />
        <span class="gu-error" *ngIf="(mode === 'create' || passwordFilled()) && !passwordsMatch() && form.get('confirmPassword')?.touched">
          {{ 'USUARIOS.PASSWORD_MISMATCH' | translate }}
        </span>
      </div>
    </div>

    <hr class="gu-divider" />

    <div class="gu-section-label">{{ 'USUARIOS.SECTION_ROLES' | translate }}</div>
    <div class="gu-chips">
      <div
        *ngFor="let rol of data.rolesDisponibles"
        class="gu-chip"
        [class.gu-chip--selected]="isRolSelected(rol.id)"
        (click)="toggleRol(rol.id)"
      >
        <mat-icon *ngIf="isRolSelected(rol.id)">check</mat-icon>
        <span>{{ rol.nombre }}</span>
      </div>
    </div>
    <div class="gu-error" *ngIf="selectedRoles.size === 0">{{ 'USUARIOS.ROLES_MIN' | translate }}</div>
    <div class="gu-field-hint">{{ 'USUARIOS.ROLES_HINT' | translate }}</div>

    <hr class="gu-divider" *ngIf="mode === 'edit'" />

    <div *ngIf="mode === 'edit'">
      <div class="gu-section-label">{{ 'USUARIOS.SECTION_STATUS' | translate }}</div>
      <label class="fb-toggle">
        <input type="checkbox" [checked]="activo" (change)="toggleActivo()" />
        <span class="fb-toggle__track">
          <span class="fb-toggle__thumb"></span>
        </span>
        <span class="fb-toggle__text">{{ (activo ? 'USUARIOS.USER_ACTIVE' : 'USUARIOS.USER_INACTIVE') | translate }}</span>
      </label>
    </div>
  </form>

  <div class="gu-dialog__footer">
    <button type="button" class="gu-btn gu-btn--ghost" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="button" class="gu-btn gu-btn--primary" [disabled]="!formIsValid()" (click)="save()">
      <mat-icon>{{ mode === 'create' ? 'add' : 'check' }}</mat-icon>
      {{ (mode === 'create' ? 'USUARIOS.CREATE_TITLE' : 'USUARIOS.SAVE_CHANGES') | translate }}
    </button>
  </div>
</div>
